import React, { createContext } from 'react'
import { FormState } from './formReducer'
import { FormSchemaMetaData } from './formInterfaces'

type FormContextType = {
    formState: FormState
    formDispatch: any
    // TODO add type here
}
const FormEngineContext = createContext<FormContextType>({
    formState: {
        dataObjectId: '',
        isNavigationEnabled: 'false',
        schema: {} as FormSchemaMetaData,
        addAuditComment: (s: string) => {},
        templateType: '',
        MetaDataMap: {},
        validatorMetaMap: {},
    },
    formDispatch: () => {},
})

export function useFormEngineContext() {
    return React.useContext(FormEngineContext)
}

export default FormEngineContext
